@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import '../../constants/spacing.module.less';

.returns-status-tabs {
  .clearfix();
  border-bottom: 1px solid @return-status-tabs--border-color;
  background-color: @return-status-tabs--background-color;
  padding: 0 @space-16;
}

.badge {
  display: inline-block;
  line-height: @space-16;
  color: @return-status-tabs--badge--text-color;
  background: @return-status-tabs--badge--background-color;
  border: 1px solid @return-status-tabs--badge--background-color;
  padding: 2px @space-8;
  margin-left: @space-8;
  border-radius: @space-16;

  &.selected {
    background: @return-status-tabs--badge--selected--background-color;
    color: @return-status-tabs--badge--selected--text-color;
  }
}
